export const DASHBOARD_SALES_REQUEST = "DASHBOARD_SALES_REQUEST";
export const DASHBOARD_SALES_SUCCESS = "DASHBOARD_SALES_SUCCESS";
export const DASHBOARD_SALES_FAIL = "DASHBOARD_SALES_FAIL";

export const DASHBOARD_REVENUE_REQUEST = "DASHBOARD_REVENUE_REQUEST";
export const DASHBOARD_REVENUE_SUCCESS = "DASHBOARD_REVENUE_SUCCESS";
export const DASHBOARD_REVENUE_FAIL = "DASHBOARD_REVENUE_FAIL";

export const DASHBOARD_TOTALORDERS_REQUEST = "DASHBOARD_TOTALORDERS_REQUEST";
export const DASHBOARD_TOTALORDERS_SUCCESS = "DASHBOARD_TOTALORDERS_SUCCESS";
export const DASHBOARD_TOTALORDERS_FAIL = "DASHBOARD_TOTALORDERS_FAIL";

export const DASHBOARD_ORDERS_REQUEST = "DASHBOARD_ORDERS_REQUEST";
export const DASHBOARD_ORDERS_SUCCESS = "DASHBOARD_ORDERS_SUCCESS";
export const DASHBOARD_ORDERS_FAIL = "DASHBOARD_ORDERS_FAIL";

export const DASHBOARD_TOPCUSTOMERS_REQUEST = "DASHBOARD_TOPCUSTOMERS_REQUEST";

export const DASHBOARD_TOPCUSTOMERS_SUCCESS = "DASHBOARD_TOPCUSTOMERS_SUCCESS";

export const DASHBOARD_TOPCUSTOMERS_FAIL = "DASHBOARD_TOPCUSTOMERS_FAIL";
